import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ElementRef, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs';

import { Alert } from './alert.model';
import { AlertService } from './alert.service';
import { AppInitializerService } from '@app/app-initializer.service';

@Component({
	selector: 'app-alert',
	templateUrl: './alert.component.html',
	styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit, OnDestroy {
	@Input() id: string;
	@Output() actionEmit: any = new EventEmitter();

	alerts: Array<Alert> = [];
	subscription: Subscription;
	timeOut;

	constructor(
		private alertService: AlertService,
		private appInit: AppInitializerService,
		private elementRef: ElementRef,
		private renderer2: Renderer2
	) { }

	ngOnInit() {
		const el: HTMLElement = this.elementRef.nativeElement;
		this.renderer2.setStyle(el, 'display', 'none');
		this.subscription = this.alertService.onAlert(this.id).subscribe((alert) => {
			if (
				(Array.isArray(alert) && !alert.length) ||
				(alert.hasOwnProperty('content') && !alert.content.text) ||
				!alert
			) {
				// clear alerts when an empty alert is received
				this.alerts = [];
				return;
			}
			// add alert to array
			const el: HTMLElement = this.elementRef.nativeElement;
			this.renderer2.setStyle(el, 'display', '');
			this.alerts.push(alert);
			// this.autoHide(this.alerts);
			if (this.alerts.length) {
				this.autoHide([alert]);
			} else {
				this.autoHide(this.alerts);
			}
		});
	}

	autoHide(alerts) {
		alerts.map((alert, index) => {
			if (alert.autoHide) {
				let duration = this.appInit.configuration.alertDuration;
				if (alert.duration) {
					duration = alert.duration;
				}
				if (this.timeOut) {
					clearTimeout(this.timeOut);
				}
				this.timeOut = setTimeout(() => {
					this.removeAlert(index);
					this.autoHide(alerts);
				}, duration);
			}
		});
	}

	ngOnDestroy() {
		// unsubscribe to avoid memory leaks
		if (this.subscription) {
			this.subscription.unsubscribe();
		}
	}

	removeAlert(index) {
		// remove specified alert from array
		this.alerts.splice(index, 1);
		const el: HTMLElement = this.elementRef.nativeElement;
		this.renderer2.setStyle(el, 'display', 'none');
	}

	actionClick(record) {
		this.actionEmit.emit(record);
	}

	cssClass(alert: Alert) {
		if (!alert) {
			return;
		}

		// return css class based on alert type
		switch (alert.type) {
			case 'SUCCESS':
				return 'Alert-box alert-success';
			case 'ERROR':
				return 'Alert-box alert-danger';
			case 'INFO':
				return 'Alert-box alert-info';
			case 'WARNING':
				return 'Alert-box alert-warning';
		}
	}
}
